import React from 'react';
import Shimmer from 'sushiweb/Shimmer';
import './DeliveryTimings.scss';

const dashboardMode = window.dashboard.mode;

export const DeliveryTimings = ({
  deliveryTimings,
  timingsType = 'Delivery Timings:',
}) => {
  return (
    <div className={`deliveryTimings tooltip ${dashboardMode}`}>
      {!deliveryTimings ? (
        <Shimmer height='300px' width='100%' />
      ) : (
        <DeliveryTimingsComp
          deliveryTimings={deliveryTimings}
          timingsType={timingsType}
        />
      )}
    </div>
  );
};

const DeliveryTimingsComp = ({ deliveryTimings, timingsType }) => {
  return (
    <React.Fragment>
      <h3 className='tooltipHeading'>{timingsType}</h3>
      {deliveryTimings.map((timing, index) => {
        let bold = {};
        bold = {
          fontWeight: timing.bold ? 'bold' : 'normal',
        };
        return (
          <div className='timingsBox' key={index}>
            <p className='day'>{timing.day}</p>
            <p className='timmings' style={bold}>
              {timing.time}
            </p>
          </div>
        );
      })}
    </React.Fragment>
  );
};
